module.exports = __webpack_public_path__ + "img/facil_acesso_icon.bd94cc79.svg";